// ©2024 Austin App House. All rights reserved.
const values = {
  documentVisibility: {},
};

export default values;
